import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './router/worker';
import { WORKER_BASE_PATH } from './utils/worker/constants';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import { IntlProvider } from 'react-intl';
import { PostHogRootProvider } from '@/contexts/_shared/PostHogContext';

const router = createBrowserRouter(routes, {
  // eslint-disable-next-line no-restricted-syntax -- module-scope router creation requires eager basename
  basename: WORKER_BASE_PATH,
  // @ts-expect-error v7_startTransition is a valid runtime flag but not yet reflected in the types for react-router-dom 6.x
  future: { v7_startTransition: true },
});

function App() {
  return (
    // In some cases components might be using useIntl() or FormattedMessage before they are properly
    // loaded. This catch-all, top-level IntlProvider makes sure that the required hooks are always
    // available even if the actual IntlProvider that has the translations is not ready.
    <IntlProvider locale="en" messages={{}} defaultLocale="en">
      <PostHogRootProvider>
        <NuqsAdapter>
          <RouterProvider
            router={router}
            future={{
              v7_startTransition: true,
            }}
          />
        </NuqsAdapter>
      </PostHogRootProvider>
    </IntlProvider>
  );
}

export default App;
